export const microphone_onboarding = {
    "seconds": 3,
    "title": {
        "en": "Recording starts in",
        "hi": "रिकॉर्डिंग शुरू होती है",
        "or": "ରେକର୍ଡିଂ ଆରମ୍ଭ ହେବ",
        "mr": "रेकॉर्डिंग सुरू होत आहे"
    }
}

export const microphone_screen = {
    3: {
        en: "Record in a quiet place",
        hi: "शांत जगह पर रिकॉर्ड करें",
        or: "ଶାନ୍ତ ସ୍ଥାନରେ ରେକର୍ଡ କରନ୍ତୁ",
        mr: "शांत ठिकाणी रेकॉर्ड करा"
    },
    2: {
        en: "Keep phone close",
        hi: "फ़ोन उचित दूरी पर रखें",
        or: "ଫୋନ୍ ପାଖରେ ରଖନ୍ତୁ",
        mr: "फोन जवळ ठेवा"
    },
    1: {
        en: "Ask in a clear voice",
        hi: "साफ़ आवाज़ में पूछें",
        or: "ସ୍ପଷ୍ଟ ସ୍ୱରରେ ପଚାରନ୍ତୁ",
        mr: "स्पष्ट आवाजात विचारा"
    }
}